module.exports = __webpack_public_path__ + "static/media/socket.io-logo.8f2f08f0.png";